import { useDispatch } from "react-redux";
import type { AnyAction } from "redux";

import { useUnmount } from "app/custom-hooks/useUnmount";
import { setSelectedRows } from "app/pages/sales-intelligence/store/find-apps/action-creators";

const useClearAndCloseRowsSelection = (
    tableRowsSelectionToggledAction: (isRowSelectionEnabled: boolean) => AnyAction,
): VoidFunction => {
    const dispatch = useDispatch();

    const clearAndCloseRowsSelection = (): void => {
        dispatch(tableRowsSelectionToggledAction(false));
        dispatch(setSelectedRows([]));
    };

    useUnmount(() => {
        clearAndCloseRowsSelection();
    });

    return clearAndCloseRowsSelection;
};

export default useClearAndCloseRowsSelection;
